import n from "./ghl-ui.es193.js";
import l from "./ghl-ui.es345.js";
var f = "Expected a function";
function u(t, a, r) {
  var e = !0, i = !0;
  if (typeof t != "function")
    throw new TypeError(f);
  return l(r) && (e = "leading" in r ? !!r.leading : e, i = "trailing" in r ? !!r.trailing : i), n(t, a, {
    leading: e,
    maxWait: a,
    trailing: i
  });
}
export {
  u as default
};
